/**
 * Sets up Visitors Onboarding Mirage Scenario
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  server.db.emptyData();

  const plans = [
    {
      app: 'visitors',
      id: 'basic',
      name: 'Basic',
      monthlyPrice: 0,
      yearlyPrice: 0,
    },
    {
      app: 'visitors',
      id: 'standard',
      name: 'Premium',
      monthlyPrice: 119,
      yearlyPrice: 99,
    },
    {
      app: 'visitors',
      id: 'standard-1',
      name: 'Standard',
      monthlyPrice: 119,
      yearlyPrice: 99,
    },
    {
      app: 'visitors',
      id: 'premium',
      name: 'Premium',
      monthlyPrice: 359,
      yearlyPrice: 299,
    },
    {
      app: 'visitors',
      id: 'enterprise',
      name: 'Enterprise',
      yearlyPrice: 999,
    },
  ];

  plans.forEach((attrs) => {
    server.create('plan', attrs);
  });

  const company = server.create('company', 'withBillingCompany', { active: true });
  server.create('location', { company });
  server.create('subscription', 'asVisitorsPremium', 'asTrialExpired', { company });

  server.create('feature', {
    company_id: company.id,
    features: ['app_visitors'],
  });
}
